import React from 'react';

export const Error404Illustration: React.FC = () => (
    <svg width="300" height="200" viewBox="0 0 300 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <circle cx="150" cy="100" r="80" fill="#F2F3F3" opacity="0.5"/>
        
        {/* Magnifying glass */}
        <circle cx="140" cy="90" r="35" stroke="#687078" strokeWidth="4" fill="none"/>
        <line x1="165" y1="115" x2="185" y2="135" stroke="#687078" strokeWidth="4" strokeLinecap="round"/>
        
        {/* Question mark inside magnifying glass */}
        <text x="140" y="100" fontSize="28" fontWeight="bold" fill="#D13212" textAnchor="middle">?</text>
        
        {/* Floating elements */}
        <circle cx="80" cy="50" r="3" fill="#879596" opacity="0.6">
            <animate attributeName="cy" values="50;45;50" dur="3s" repeatCount="indefinite"/>
        </circle>
        <circle cx="220" cy="60" r="2" fill="#879596" opacity="0.4">
            <animate attributeName="cy" values="60;55;60" dur="2.5s" repeatCount="indefinite"/>
        </circle>
        <circle cx="100" cy="140" r="2.5" fill="#879596" opacity="0.5">
            <animate attributeName="cy" values="140;135;140" dur="2s" repeatCount="indefinite"/>
        </circle>
        <circle cx="200" cy="130" r="2" fill="#879596" opacity="0.3">
            <animate attributeName="cy" values="130;125;130" dur="3.5s" repeatCount="indefinite"/>
        </circle>
        
        {/* 404 text */}
        <text x="150" y="180" fontSize="48" fontWeight="200" fill="#E9EBED" textAnchor="middle" fontFamily="Arial">404</text>
    </svg>
);

export const Error403Illustration: React.FC = () => (
    <svg width="300" height="200" viewBox="0 0 300 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <circle cx="150" cy="100" r="80" fill="#FEF2F2" opacity="0.5"/>
        
        {/* Lock body */}
        <rect x="120" y="90" width="60" height="45" rx="4" fill="#D13212"/>
        
        {/* Lock shackle */}
        <path d="M130 90 L130 75 Q150 55 170 75 L170 90" stroke="#D13212" strokeWidth="6" fill="none" strokeLinecap="round"/>
        
        {/* Keyhole */}
        <circle cx="150" cy="105" r="5" fill="white"/>
        <rect x="147" y="105" width="6" height="15" fill="white"/>
        
        {/* Shield background */}
        <path d="M150 40 L190 60 L190 100 Q190 140 150 160 Q110 140 110 100 L110 60 Z" 
              stroke="#687078" strokeWidth="2" fill="none" opacity="0.3" strokeDasharray="5,5">
            <animate attributeName="stroke-dashoffset" values="0;10" dur="2s" repeatCount="indefinite"/>
        </path>
        
        {/* Warning elements */}
        <circle cx="80" cy="60" r="15" fill="none" stroke="#FF9900" strokeWidth="2" opacity="0.5">
            <animate attributeName="r" values="15;20;15" dur="2s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0.5;0.2;0.5" dur="2s" repeatCount="indefinite"/>
        </circle>
        <circle cx="220" cy="100" r="15" fill="none" stroke="#FF9900" strokeWidth="2" opacity="0.5">
            <animate attributeName="r" values="15;20;15" dur="2s" repeatCount="indefinite" begin="1s"/>
            <animate attributeName="opacity" values="0.5;0.2;0.5" dur="2s" repeatCount="indefinite" begin="1s"/>
        </circle>
    </svg>
);

export const Error500Illustration: React.FC = () => (
    <svg width="300" height="200" viewBox="0 0 300 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <circle cx="150" cy="100" r="80" fill="#FEF2F2" opacity="0.3"/>
        
        {/* Server rack */}
        <rect x="110" y="60" width="80" height="80" rx="4" fill="#687078"/>
        
        {/* Server slots */}
        <rect x="120" y="70" width="60" height="15" rx="2" fill="#879596"/>
        <rect x="120" y="90" width="60" height="15" rx="2" fill="#879596"/>
        <rect x="120" y="110" width="60" height="15" rx="2" fill="#D91515"/>
        
        {/* Blinking lights */}
        <circle cx="170" cy="77" r="3" fill="#00C181">
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite"/>
        </circle>
        <circle cx="170" cy="97" r="3" fill="#00C181">
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite" begin="0.3s"/>
        </circle>
        <circle cx="170" cy="117" r="3" fill="#D91515">
            <animate attributeName="opacity" values="1;0.3;1" dur="0.5s" repeatCount="indefinite"/>
        </circle>
        
        {/* Smoke/Steam effect */}
        <circle cx="140" cy="50" r="4" fill="#687078" opacity="0.3">
            <animate attributeName="cy" values="50;30;50" dur="3s" repeatCount="indefinite"/>
            <animate attributeName="opacity" values="0.3;0;0.3" dur="3s" repeatCount="indefinite"/>
            <animate attributeName="r" values="4;8;4" dur="3s" repeatCount="indefinite"/>
        </circle>
        <circle cx="150" cy="50" r="5" fill="#687078" opacity="0.3">
            <animate attributeName="cy" values="50;25;50" dur="3s" repeatCount="indefinite" begin="0.5s"/>
            <animate attributeName="opacity" values="0.3;0;0.3" dur="3s" repeatCount="indefinite" begin="0.5s"/>
            <animate attributeName="r" values="5;10;5" dur="3s" repeatCount="indefinite" begin="0.5s"/>
        </circle>
        <circle cx="160" cy="50" r="4" fill="#687078" opacity="0.3">
            <animate attributeName="cy" values="50;30;50" dur="3s" repeatCount="indefinite" begin="1s"/>
            <animate attributeName="opacity" values="0.3;0;0.3" dur="3s" repeatCount="indefinite" begin="1s"/>
            <animate attributeName="r" values="4;8;4" dur="3s" repeatCount="indefinite" begin="1s"/>
        </circle>
        
        {/* Warning sign */}
        <path d="M150 20 L160 35 L140 35 Z" fill="#FF9900"/>
        <text x="150" y="32" fontSize="12" fontWeight="bold" fill="white" textAnchor="middle">!</text>
        
        {/* Connection lines with error */}
        <line x1="190" y1="77" x2="220" y2="77" stroke="#687078" strokeWidth="2" strokeDasharray="5,3"/>
        <line x1="190" y1="97" x2="220" y2="97" stroke="#687078" strokeWidth="2" strokeDasharray="5,3"/>
        <line x1="190" y1="117" x2="220" y2="117" stroke="#D91515" strokeWidth="2" strokeDasharray="5,3">
            <animate attributeName="stroke-dashoffset" values="0;8" dur="1s" repeatCount="indefinite"/>
        </line>
        
        {/* X mark for error */}
        <g transform="translate(230, 117)">
            <line x1="-5" y1="-5" x2="5" y2="5" stroke="#D91515" strokeWidth="2" strokeLinecap="round"/>
            <line x1="5" y1="-5" x2="-5" y2="5" stroke="#D91515" strokeWidth="2" strokeLinecap="round"/>
        </g>
    </svg>
);

export const ErrorGenericIllustration: React.FC = () => (
    <svg width="300" height="200" viewBox="0 0 300 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background circle */}
        <circle cx="150" cy="100" r="80" fill="#FFF4E5" opacity="0.3"/>
        
        {/* Warning triangle */}
        <path d="M150 40 L200 130 L100 130 Z" stroke="#FF9900" strokeWidth="3" fill="none"/>
        <path d="M150 50 L195 125 L105 125 Z" fill="#FFF4E5"/>
        
        {/* Exclamation mark */}
        <rect x="147" y="75" width="6" height="30" rx="3" fill="#FF9900"/>
        <circle cx="150" cy="115" r="4" fill="#FF9900"/>
        
        {/* Floating gears */}
        <g transform="translate(80, 60)">
            <circle cx="0" cy="0" r="15" fill="none" stroke="#687078" strokeWidth="2" opacity="0.3"/>
            <circle cx="0" cy="0" r="8" fill="none" stroke="#687078" strokeWidth="2" opacity="0.3"/>
            {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
                <rect key={i} x="-2" y="-15" width="4" height="30" fill="#687078" opacity="0.3"
                      transform={`rotate(${angle})`}/>
            ))}
            <animateTransform attributeName="transform" type="rotate" values="0;360" dur="10s" repeatCount="indefinite"/>
        </g>
        
        <g transform="translate(220, 100)">
            <circle cx="0" cy="0" r="12" fill="none" stroke="#687078" strokeWidth="2" opacity="0.2"/>
            <circle cx="0" cy="0" r="6" fill="none" stroke="#687078" strokeWidth="2" opacity="0.2"/>
            {[0, 60, 120, 180, 240, 300].map((angle, i) => (
                <rect key={i} x="-2" y="-12" width="4" height="24" fill="#687078" opacity="0.2"
                      transform={`rotate(${angle})`}/>
            ))}
            <animateTransform attributeName="transform" type="rotate" values="360;0" dur="8s" repeatCount="indefinite"/>
        </g>
        
        {/* Dotted path */}
        <path d="M50 150 Q150 140 250 150" stroke="#687078" strokeWidth="2" fill="none" 
              strokeDasharray="5,5" opacity="0.3">
            <animate attributeName="stroke-dashoffset" values="0;10" dur="2s" repeatCount="indefinite"/>
        </path>
    </svg>
);

export const getErrorIllustration = (errorCode: string) => {
    switch (errorCode) {
        case '404':
            return <Error404Illustration />;
        case '403':
            return <Error403Illustration />;
        case '500':
            return <Error500Illustration />;
        default:
            return <ErrorGenericIllustration />;
    }
};
